import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';
import { Flags } from 'react-feature-flags';
import { FormattedMessage } from 'react-intl';
import { useRouteWidgetContext } from '../../context/RouteWidgetContext';
import {
    commonBodyClassName,
    commonExpanderClassName,
    commonHeaderClassName,
} from '../SettingsOptions/SettingsOptions';
import { GradingOptions } from './GradingOptions';
import { OperatorOptions } from './OperatorOptions';
import { PaymentOptions } from './PaymentOptions';
import { PlugTypeOptions } from './PlugTypeOptions';
import { PowerOptions } from './PowerOptions';
import { SoCOptions } from './SoCOptions';

export const ChargingOptions = () => {
    const widgetContext = useRouteWidgetContext();

    return (
        <div className={`ChargingOptions margin-top-5 ${commonHeaderClassName}`} data-testid='charging-options'>
            <SoCOptions />

            <Flags authorizedFlags={['chargingOptions']}>
                <ExpanderPanel
                    bsStyle='default'
                    className={commonExpanderClassName}
                    bodyClassName={commonBodyClassName}
                    title={<FormattedMessage id='intl-msg:smartRoute.generic.options' />}
                    onToggle={(value: boolean) => {
                        widgetContext.setCharginOptionsExpnd(value);
                    }}
                    open={widgetContext.charginOptionsExpnd}
                >
                    <GradingOptions />
                    <PlugTypeOptions />
                    <PowerOptions />
                    <OperatorOptions />
                    <PaymentOptions />
                </ExpanderPanel>
            </Flags>
        </div>
    );
};
